export const BRANCH_OPTIONS = [
  { value: 'airforce', labelId: 'experience.form.branch.airforce', backendName: 'Air Force', apiValue: 'airForce' },
  {
    value: 'airnationalguard',
    labelId: 'experience.form.branch.airnationalguard',
    backendName: 'Air National Guard',
    apiValue: 'airNationalGuard',
  },
  { value: 'army', labelId: 'experience.form.branch.army', backendName: 'Army', apiValue: 'army' },
  {
    value: 'armynationalguard',
    labelId: 'experience.form.branch.armynationalguard',
    backendName: 'Army National Guard',
    apiValue: 'armyNationalGuard',
  },
  {
    value: 'coastguard',
    labelId: 'experience.form.branch.coastguard',
    backendName: 'Coast Guard',
    apiValue: 'coastGuard',
  },
  {
    value: 'marinecorps',
    labelId: 'experience.form.branch.marinecorps',
    backendName: 'Marine Corps',
    apiValue: 'marineCorps',
  },
  { value: 'navy', labelId: 'experience.form.branch.navy', backendName: 'Navy', apiValue: 'navy' },
  {
    value: 'spaceforce',
    labelId: 'experience.form.branch.spaceforce',
    backendName: 'Space Force',
    apiValue: 'spaceForce',
  },
];

// Map ordinal abbreviations to word form for backend enum compatibility
const ORDINAL_MAP = { '1st': 'first', '2nd': 'second', '3rd': 'third', '4th': 'fourth', '5th': 'fifth' };

export const createRanks = (labels) =>
  labels.map((label) => ({
    value: label
      .replace(/[^a-zA-Z0-9]+/g, ' ')
      .trim()
      .split(' ')
      .map((word, i) => {
        const mapped = ORDINAL_MAP[word.toLowerCase()] || word;
        return i === 0 ? mapped.toLowerCase() : mapped.charAt(0).toUpperCase() + mapped.slice(1).toLowerCase();
      })
      .join(''),
    label,
  }));

const armyBasedRanks = createRanks([
  'Private (Recruit)',
  'Private',
  'Private First Class',
  'Specialist',
  'Corporal',
  'Sergeant',
  'Staff Sergeant',
  'Sergeant First Class',
  'Master Sergeant',
  'First Sergeant',
  'Sergeant Major',
  'Command Sergeant Major',
  'Warrant Officer 1',
  'Chief Warrant Officer 2',
  'Chief Warrant Officer 3',
  'Chief Warrant Officer 4',
  'Chief Warrant Officer 5',
  '2nd Lieutenant',
  '1st Lieutenant',
  'Captain',
  'Major',
  'Lieutenant Colonel',
  'Colonel',
  'Brigadier General',
  'Major General',
  'Lieutenant General',
  'General',
  'Army Chief of Staff',
]);

const navalRanks = createRanks([
  'Seaman Recruit',
  'Seaman Apprentice',
  'Seaman',
  'Petty Officer Third Class',
  'Petty Officer Second Class',
  'Petty Officer First Class',
  'Chief Petty Officer',
  'Senior Chief Petty Officer',
  'Master Chief Petty Officer',
  'Warrant Officer 1',
  'Chief Warrant Officer 2',
  'Chief Warrant Officer 3',
  'Chief Warrant Officer 4',
  'Chief Warrant Officer 5',
  'Ensign',
  'Lieutenant, Junior Grade',
  'Lieutenant',
  'Lieutenant Commander',
  'Commander',
  'Captain',
  'Rear Admiral (Commodore)',
  'Rear Admiral (Upper Half)',
  'Vice Admiral',
  'Admiral',
  'Chief of Naval Operations',
]);

const coastGuardRanks = createRanks([
  'Seaman Recruit',
  'Seaman Apprentice',
  'Seaman',
  'Petty Officer Third Class',
  'Petty Officer Second Class',
  'Petty Officer First Class',
  'Chief Petty Officer',
  'Senior Chief Petty Officer',
  'Master Chief Petty Officer',
  'Warrant Officer 1',
  'Chief Warrant Officer 2',
  'Chief Warrant Officer 3',
  'Chief Warrant Officer 4',
  'Chief Warrant Officer 5',
  'Ensign',
  'Lieutenant, Junior Grade',
  'Lieutenant',
  'Lieutenant Commander',
  'Commander',
  'Captain',
  'Rear Admiral (Commodore)',
  'Rear Admiral (Upper Half)',
  'Vice Admiral',
  'Admiral',
  'Commandant of the Coast Guard',
]);

const airForceRanks = createRanks([
  'Airman Basic',
  'Airman',
  'Airman First Class',
  'Senior Airman',
  'Staff Sergeant',
  'Technical Sergeant',
  'Master Sergeant',
  'First Sergeant (E-7)',
  'Senior Master Sergeant',
  'First Sergeant (E-8)',
  'Chief Master Sergeant',
  'First Sergeant (E-9)',
  'Command Chief Master Sergeant',
  'Warrant Officer 1',
  'Chief Warrant Officer 2',
  'Chief Warrant Officer 3',
  'Chief Warrant Officer 4',
  'Chief Warrant Officer 5',
  '2nd Lieutenant',
  '1st Lieutenant',
  'Captain',
  'Major',
  'Lieutenant Colonel',
  'Colonel',
  'Brigadier General',
  'Major General',
  'Lieutenant General',
  'General',
  'Air Force Chief of Staff',
]);

export const RANKS_BY_BRANCH = {
  airforce: airForceRanks,
  army: armyBasedRanks,
  navy: navalRanks,
  coastguard: coastGuardRanks,
  airnationalguard: airForceRanks,
  armynationalguard: armyBasedRanks,
  spaceforce: [
    { value: 'specialist1', label: 'Specialist 1' },
    { value: 'specialist2', label: 'Specialist 2' },
    { value: 'specialist3', label: 'Specialist 3' },
    { value: 'specialist4', label: 'Specialist 4' },
    { value: 'sergeant', label: 'Sergeant' },
    { value: 'technicalSergeant', label: 'Technical Sergeant' },
    { value: 'masterSergeant', label: 'Master Sergeant' },
    { value: 'seniorMasterSergeant', label: 'Senior Master Sergeant' },
    { value: 'chiefMasterSergeant', label: 'Chief Master Sergeant' },
    { value: 'chiefMasterSergeantOfTheSpaceForce', label: 'Chief Master Sergeant of the Space Force' },
    { value: 'secondLieutenant', label: '2nd Lieutenant' },
    { value: 'firstLieutenant', label: '1st Lieutenant' },
    { value: 'captain', label: 'Captain' },
    { value: 'major', label: 'Major' },
    { value: 'lieutenantColonel', label: 'Lieutenant Colonel' },
    { value: 'colonel', label: 'Colonel' },
    { value: 'brigadierGeneral', label: 'Brigadier General' },
    { value: 'majorGeneral', label: 'Major General' },
    { value: 'lieutenantGeneral', label: 'Lieutenant General' },
    { value: 'general', label: 'General' },
  ],
  marinecorps: createRanks([
    'Private',
    'Private First Class',
    'Lance Corporal',
    'Corporal',
    'Sergeant',
    'Staff Sergeant',
    'Gunnery Sergeant',
    'Master Sergeant',
    'First Sergeant',
    'Master Gunnery Sergeant',
    'Sergeant Major',
    'Warrant Officer',
    'Chief Warrant Officer 2',
    'Chief Warrant Officer 3',
    'Chief Warrant Officer 4',
    'Chief Warrant Officer 5',
    '2nd Lieutenant',
    '1st Lieutenant',
    'Captain',
    'Major',
    'Lieutenant Colonel',
    'Colonel',
    'Brigadier General',
    'Major General',
    'Lieutenant General',
    'General',
    'Commandant of the Marine Corps',
  ]),
};

export const BRANCH_TO_API_VALUE = {
  airforce: 'air_force',
  airnationalguard: 'air_force',
  army: 'army',
  armynationalguard: 'army',
  coastguard: 'coast_guard',
  marinecorps: 'marine_corps',
  navy: 'navy',
  spaceforce: 'space_force',
};

export const MILITARY_STATUS_OPTIONS = createRanks(['Active', 'Reserve', 'Separated']);

export const PERSONAL_CATEGORY_OPTIONS = createRanks([
  'Enlisted',
  'Non-Commisioned Officer',
  'Commisioned Officer',
  'Warrant Officer',
  'Civiliant',
]);

export const CREDIT_AREA_CREDIT_TYPE_OPTIONS = createRanks([
  'S/SH=Semester Hours',
  'Q=Quarter Hours',
  'C=Clock Hours',
  'N=Continuing Education Units',
]);

export const CREDIT_AREA_LEVEL_OPTIONS = createRanks([
  'V=Vocational',
  'L=Lower Division Baccalaureate/Associate',
  'U=Upper Division Baccalaureate',
  'G=Graduate',
  'E=Continuing Education',
  'D=Development',
]);

export const CLEP_TITLES = createRanks([
  'American Literature',
  'Analyzing and Interpreting Literature',
  'College Composition',
  'College Composition Modular',
  'English Literature',
  'Humanities',
  'French Language: Level 1',
  'French Language: Level 2',
  'German Language: Level 1',
  'German Language: Level 2',
  'Spanish Language: Level 1',
  'Spanish Language: Level 2',
  'Spanish with Writing: Level 1',
  'Spanish with Writing: Level 2',
  'American Government',
  'History of the United States',
  'History of the United States II',
  'Human Growth and Development',
  'Introduction to Educational Psychology',
  'Introductory Psychology',
  'Introductory Sociology',
  'Principles of Macroeconomics',
  'Principles of Microeconomics',
  'Social Sciences and History',
  'Western Civilization I: Ancient Near East to 1648',
  'Western Civilization II: 1648 to Present',
  'Biology',
  'Calculus',
  'Chemistry',
  'College Algebra',
  'College Mathematics',
  'Natural Sciences',
  'Precalculus',
  'Financial Accounting',
  'Information Systems',
  'Introductory Business Law',
  'Principles of Management',
  'Principles of Marketing',
  'Other',
  'Business Ethics and Society',
  'Business Mathematics',
  'Human Resource Management',
  'Introduction to Business',
  'Management Information Systems',
  'Organizational Behavior',
  'Money and Banking',
  'Personal Finance',
  'Principles of Finance',
  'Principles of Supervision',
  'Computing and Information Technology',
  'Ethics in America',
  'Introduction to World Religions',
  'Principles of Public Speaking',
  'Principles of Advanced English Composition',
  'Fundamentals of College Algebra',
  'Principles of Statistics',
  'Math for Liberal Arts',
  'Astronomy',
  'Environmental Science (formerly Environment and Humanity: The Race to Save the Planet)',
  `Health and Development (formerly Here's to Your Health)`,
  'Introduction to Geology',
  'A History of the Vietnam War',
  'Art of the Western World',
  'Criminal Justice',
  'Foundations of Education',
  'Fundamentals of Counseling',
  'General Anthropology',
  'Introduction to Geography (formerly Human/Cultural Geography)',
  'Introduction to Law Enforcement',
  'Lifespan Developmental Psychology',
  'History of the Soviet Union (formerly Rise and Fall of the Soviet Union)',
  'Substance Abuse',
  'The Civil War and Reconstruction',
  'Fundamentals of Cybersecurity',
  'Technical Writing',
  'Ethics in Technology',
]);

export const DLPT_LANGUAGE_OPTIONS = createRanks([
  'ALBANIAN',
  'AMHARIC',
  'ARABIC-ALGERIAN',
  'ARABIC-IRAQI',
  'ARABIC-LEVANTINE',
  'ARABIC-MSA',
  'ARABIC-SAUDI',
  'ARABIC-SUDANESE',
  'ARABIC-YEMENI',
  'AZERBAIJANI',
  'BURMESE',
  'CAMBODIAN',
  'CANTONESE',
  'CEBUANO',
  'CHAVACANO',
  'CHINESE-AMOY',
  'CHINESE-MANDARIN',
  'CZECH',
  'DANISH',
  'DARI-AFGHAN',
  'EGYPTIAN',
  'FRENCH',
  'GERMAN',
  'GREEK',
  'HAITIAN CREOLE',
  'HAUSA',
  'HEBREW',
  'HINDI',
  'HUNGARIAN',
  'INDONESIAN',
  'ITALIAN',
  'JAPANESE',
  'KOREAN',
  'KURDISH-KURMANJI',
  'KURDISH-SORANI',
  'LAO',
  'LITHUANIAN',
  'NORWEGIAN',
  'PASHTO-AFGHAN',
  'PERSIAN-AFGHAN',
  'PERSIAN-FARSI',
  'POLISH',
  'PORTUGUESE',
  'PUNJABI',
  'ROMANIAN',
  'RUSSIAN',
  'SERBIAN/CROATIAN',
  'SLOVENIAN',
  'SOMALI',
  'SPANISH',
  'SWAHILI',
  'SWEDISH',
  'TAGALOG',
  'TAUSUG',
  'THAI',
  'TURKISH',
  'UKRAINIAN',
  'URDU',
  'UZBEK',
  'VIETNAMESE',
  'YIDDISH',
  'YORUBA',
  'OTHER',
]);
